var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
      },
    },
    [
      _c("g", { attrs: { fill: _vm.color } }, [
        _c("path", { attrs: { d: "M2.75 2.75h16.5v16.5h-16.5z" } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }